import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "serviceStatusSearch" }
const _hoisted_2 = ["id", "for"]
const _hoisted_3 = ["aria-label"]

import {
  ref, watch, nextTick, onMounted, computed,
} from 'vue';
import vClickOutside from '@venegrad/vue3-click-outside';
import { Searchbox, Icon } from '../../Atoms';
import { RecentSearches } from '../../Molecules';
import { RecentOrSuggestedSearchEntry } from '../../types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceStatusSearchbox',
  props: {
    placeholder: {},
    searchInputId: {},
    searchInputLabel: {},
    disabled: { type: Boolean },
    suggestions: {},
    suggestionsTitle: {},
    showSearches: { type: Boolean },
    showRouteMapButton: { type: Boolean },
    selectRouteMapCallback: { type: Function },
    hideSearchBtn: { type: Boolean }
  },
  emits: [
  'updateSearchValue',
  'clearSearchValue',
  'setShowSearches',
  'getIsFocus',
  'searchClick',
  'deleteSearch',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchValue = ref('');
const placeholder = ref(props.placeholder);
const searchBox = ref(null);

const resolvedLabelId = computed(() => props.searchInputLabel || 'serviceStatusLabel');

const hideSuggestions = () => {
  emit('setShowSearches', false);
};

const setSearchValue = (value) => {
  let inputText;
  value.ports.forEach((portname) => {
    inputText = inputText !== undefined ? `${inputText} - ${portname.name}` : portname.name;
  });

  searchValue.value = inputText;
  emit('updateSearchValue', inputText);
};

const searchClick = () => {
  if (searchValue.value.trim().length !== 0) {
    emit('searchClick');
  }
};

const clearSearch = () => {
  searchValue.value = '';
  emit('clearSearchValue');

  nextTick(() => {
    if (searchBox.value?.$el) {
      const input = searchBox.value.$el.querySelector('input');
      input?.focus();
    }
  });
};

const applyAriaLabelledbyFix = async () => {
  await nextTick();
  const inputEl = searchBox.value?.$el?.querySelector('input');
  if (inputEl && resolvedLabelId.value) {
    inputEl.setAttribute('aria-labelledby', resolvedLabelId.value);
  }
};

onMounted(applyAriaLabelledbyFix);
watch(searchValue, applyAriaLabelledbyFix);
watch(() => props.searchInputLabel, applyAriaLabelledbyFix);

watch(() => props.placeholder, (newPlaceholder) => {
  placeholder.value = newPlaceholder;
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      id: _ctx.searchInputLabel ? _ctx.searchInputLabel : 'serviceStatusLabel',
      for: _ctx.searchInputId ? _ctx.searchInputId : 'serviceStatusInput'
    }, _toDisplayString(_ctx.$t('Search routes')), 9, _hoisted_2),
    _createVNode(_unref(Searchbox), {
      id: _ctx.searchInputId ? _ctx.searchInputId : 'serviceStatusInput',
      ref_key: "searchBox",
      ref: searchBox,
      "aria-expanded": _ctx.showSearches,
      "aria-haspopup": "listbox",
      "aria-controls": "serviceStatusListbox",
      placeholder: placeholder.value,
      value: searchValue.value,
      disabled: _ctx.disabled ?? false,
      "hide-search-btn": _ctx.hideSearchBtn,
      error: false,
      onUpdate: _cache[0] || (_cache[0] = (value) => {
        searchValue.value = value;
        _ctx.$emit('updateSearchValue', searchValue.value);
      }),
      onSearchClick: searchClick,
      onSetIsFocus: _cache[1] || (_cache[1] = (isFocus) => _ctx.$emit('getIsFocus', isFocus))
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("button", {
          class: _normalizeClass(["clearButton", { noSearchBtn: !_ctx.hideSearchBtn }]),
          "aria-label": _ctx.$t('Clear'),
          onClick: clearSearch
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t('Clear')) + " ", 1),
          _createVNode(_unref(Icon), {
            "icon-name": "close",
            sm: ""
          })
        ], 10, _hoisted_3), [
          [_vShow, searchValue.value.length > 0]
        ])
      ]),
      _: 1
    }, 8, ["id", "aria-expanded", "placeholder", "value", "disabled", "hide-search-btn"]),
    _createVNode(_unref(RecentSearches), {
      title: _ctx.suggestionsTitle,
      "aria-labelledby": "serviceStatusLabel",
      "aria-id": "serviceStatusListbox",
      "show-searches": _ctx.showSearches,
      searches: _ctx.suggestions,
      "show-route-map-button": _ctx.showRouteMapButton,
      "select-route-map-callback": _ctx.selectRouteMapCallback,
      onSetSearchValue: _cache[2] || (_cache[2] = (value) => setSearchValue(value)),
      onSetShowSearches: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setShowSearches'))),
      onSearchClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('searchClick'))),
      onDeleteSearch: _cache[5] || (_cache[5] = (search) => _ctx.$emit('deleteSearch', search))
    }, null, 8, ["title", "show-searches", "searches", "show-route-map-button", "select-route-map-callback"]),
    _renderSlot(_ctx.$slots, "default")
  ])), [
    [_unref(vClickOutside), hideSuggestions]
  ])
}
}

})